import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";


export const bookerVoucherRoute: RouteConfig<'with-page'> = {
    name: 'Booker Voucher',
    path: '/rewards/booker/vouchers',
    page: lazy(() => import('.')),
    flags: ['member-route'],
    permissions: ['rewards'],
    context: "member",
}